import { Type } from "@sinclair/typebox";
export const BlobReferenceSchema = Type.Object({
    blobId: Type.BigInt(),
    canisterId: Type.String(),
});
export const DataContentSchema = Type.Object({
    blobReference: Type.Optional(BlobReferenceSchema),
    blobData: Type.Optional(Type.Uint8Array()),
    blobUrl: Type.Optional(Type.String()),
});
